// src/components/directory/FilterBar.jsx
// Covers: DS-02 DS-03 DS-04 DS-05

import React from 'react';
import styles from './FilterBar.module.css';

const CATEGORIES = [
  { value:'all',        label:'All' },
  { value:'mental',     label:'Mental health' },
  { value:'financial',  label:'Financial' },
  { value:'housing',    label:'Housing' },
  { value:'employment', label:'Employment' },
  { value:'family',     label:'Family' },
  { value:'medical',    label:'Medical' },
  { value:'indigenous', label:'Indigenous' },
];

const PROVINCES = [
  { value:'all', label:'All of Canada' },
  { value:'BC',  label:'BC' },
  { value:'AB',  label:'Alberta' },
  { value:'SK',  label:'Saskatchewan' },
  { value:'MB',  label:'Manitoba' },
  { value:'ON',  label:'Ontario' },
  { value:'QC',  label:'Quebec' },
  { value:'NS',  label:'Nova Scotia' },
  { value:'NB',  label:'New Brunswick' },
  { value:'PE',  label:'PEI' },
  { value:'NL',  label:'Newfoundland' },
  { value:'YT',  label:'Yukon' },
  { value:'NT',  label:'Northwest Territories' },
  { value:'NU',  label:'Nunavut' },
  { value:'National', label:'National only' },
];

export default function FilterBar({
  category, province, freeOnly, noReferral, familyOK,
  onCategoryChange, onProvinceChange,
  onFreeOnlyChange, onNoReferralChange, onFamilyOKChange,
}) {
  return (
    <div className={styles.bar}>
      {/* Category chips — DS-02 */}
      <div className={styles.chipRow}>
        <span className={styles.label}>Category</span>
        {CATEGORIES.map(c => (
          <button
            key={c.value}
            className={`${styles.chip} ${category === c.value ? styles.active : ''}`}
            onClick={() => onCategoryChange(c.value)}
          >
            {c.label}
          </button>
        ))}
      </div>

      {/* Second row — province + access filters */}
      <div className={styles.chipRow}>
        {/* Province — DS-03 */}
        <span className={styles.label}>Region</span>
        <select
          className={styles.select}
          value={province}
          onChange={e => onProvinceChange(e.target.value)}
          aria-label="Filter by province"
        >
          {PROVINCES.map(p => (
            <option key={p.value} value={p.value}>{p.label}</option>
          ))}
        </select>

        <div className={styles.divider} />

        {/* Access toggles — DS-04, DS-05 */}
        <span className={styles.label}>Access</span>

        <button
          className={`${styles.chip} ${freeOnly ? styles.active : ''}`}
          onClick={() => onFreeOnlyChange(!freeOnly)}
          aria-pressed={freeOnly}
        >
          Free programs
        </button>

        <button
          className={`${styles.chip} ${noReferral ? styles.active : ''}`}
          onClick={() => onNoReferralChange(!noReferral)}
          aria-pressed={noReferral}
        >
          No referral needed
        </button>

        {/* DS-04 — family accessible filter */}
        <button
          className={`${styles.chip} ${familyOK ? styles.active : ''}`}
          onClick={() => onFamilyOKChange(!familyOK)}
          aria-pressed={familyOK}
        >
          Family can access directly
        </button>
      </div>
    </div>
  );
}
